module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "address-detail-content",
    style: ({
      'padding-bottom': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '50px'
    })
  }, [_c('div', {
    staticClass: "content-2"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("收货人")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressInfo.consignee),
      expression: "expressInfo.consignee",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "txt_1",
    attrs: {
      "type": "text",
      "placeholder": "请填写姓名"
    },
    domProps: {
      "value": (_vm.expressInfo.consignee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expressInfo, "consignee", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressInfo.expressMobile),
      expression: "expressInfo.expressMobile",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "info",
    attrs: {
      "type": "text",
      "placeholder": "请填写您的手机号"
    },
    domProps: {
      "value": (_vm.expressInfo.expressMobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expressInfo, "expressMobile", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('van-field', {
    attrs: {
      "name": "picker",
      "label": "省",
      "placeholder": "点击选择省份"
    },
    on: {
      "click": function($event) {
        _vm.showPicker = true
      }
    },
    model: {
      value: (_vm.expressInfo.province),
      callback: function($$v) {
        _vm.$set(_vm.expressInfo, "province", $$v)
      },
      expression: "expressInfo.province"
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "round": "",
      "position": "bottom"
    },
    model: {
      value: (_vm.showPicker),
      callback: function($$v) {
        _vm.showPicker = $$v
      },
      expression: "showPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.provinceOptions
    },
    on: {
      "confirm": _vm.onConfirm,
      "cancel": function($event) {
        _vm.showPicker = false
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('van-field', {
    attrs: {
      "name": "picker",
      "label": "市",
      "placeholder": "点击选择市"
    },
    on: {
      "click": function($event) {
        _vm.showCityPicker = true
      }
    },
    model: {
      value: (_vm.expressInfo.city),
      callback: function($$v) {
        _vm.$set(_vm.expressInfo, "city", $$v)
      },
      expression: "expressInfo.city"
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showCityPicker),
      callback: function($$v) {
        _vm.showCityPicker = $$v
      },
      expression: "showCityPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.cityOptions
    },
    on: {
      "confirm": _vm.onConfirm2,
      "cancel": function($event) {
        _vm.showCityPicker = false
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("*街道(不包含省市)")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.expressInfo.street),
      expression: "expressInfo.street",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "info",
    attrs: {
      "placeholder": "请填写街道信息"
    },
    domProps: {
      "value": (_vm.expressInfo.street)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.expressInfo, "street", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-content"
  }, [_c('div', {
    staticClass: "del-btn",
    on: {
      "click": _vm.gotolast
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("删除")])]), _vm._v(" "), _c('div', {
    staticClass: "sub-btn",
    on: {
      "click": _vm.submit
    }
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('footer-placeholder')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf236dc2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_v_2.6/MyAddress/AddAddress.vue
// module id = 1725
// module chunks = 8